import React, { useState, useRef, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import {
  AddCharty,
  FindCharity,
  GetCharity,
  GetAllBeneficiary,
} from "../../api/get";
import Modal from "react-responsive-modal";
import { SaveCharity } from "../../api/api";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../loader";
import Header from "../../Common/Header";
import { FaAngleLeft } from "react-icons/fa6";
import { useFormik } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import { FaChevronRight } from "react-icons/fa";
import Spinner from "../../Common/Spinner";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { handleApiError } from "../../Common/Helper";
const Charity = () => {
  const [charities, setCharityData] = useState([]);
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [errorMessage, setErrorMessage] = useState(""); // State for error message
  const [openModal, setOpenModal] = useState();
  const [searchCharity, setSearchCharity] = useState([]);
  const [saveCharity, setSaveCharity] = useState([]);
  const [searchCharityData, setSearchCharityData] = useState([]);
  const [contentLoader, setContentLoader] = useState(true);
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [selectedCharities, setSelectedCharities] = useState([]); // To store the selected charities
  const freeSearchInputRef = useRef(null); // Create a ref for the search input container
  const navigate = useNavigate();
  useEffect(() => {
    // Fetch personal details and relationships and set form values once loaded
    Promise.all([GetCharity(), GetAllBeneficiary()])
      .then(([charities, beneficiaries]) => {
        if (
          charities.success &&
          beneficiaries.success &&
          charities.status_code === "200" &&
          beneficiaries.status_code === "200"
        ) {
          setCharityData(charities.data);
          setBeneficiaries(beneficiaries.data);
          setContentLoader(false);
        } else if (!charities.success && charities.status_code == "401") {
          handleApiError(charities, navigate); // Use helper function
        } else if (!beneficiaries.success && beneficiaries.status_code == "401") {
          handleApiError(beneficiaries, navigate); // Use helper function
        }
      })
      .catch((err) => console.error("Error fetching data", err));
  }, []);
  console.log("charityData =>", charities);
  const handleSearchCharity = (e) => {
    const inputValue = e.target.value.trim(); // Remove any extra whitespace
    setSearchInput(inputValue);
    if (inputValue.length !== 0) {
      // Assuming `selectedCharities` is an array holding the selected charity IDs
      const type = "without_default_charity";
      const charitiesIds = charities.map((charity) => charity.id);
      FindCharity(inputValue, charitiesIds, type)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            console.log(res);
            setSearchCharity(res.data);
          } else {
            handleApiError(res, navigate); // Use helper function
          }
          // setSearchInput(e.target.value);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setSearchCharity([]);
    }
  };
  // console.log("search Input =>", searchInput);
  // console.log("searchCharity =>", searchCharity);
  // Function to handle clicks outside of the .free_search_input div
  const handleClickOutside = (e) => {
    if (
      freeSearchInputRef.current &&
      !freeSearchInputRef.current.contains(e.target)
    ) {
      // If the click is outside the free_search_input, reset searchInput
      setSearchInput("");
    }
  };

  // Adding event listener when the component mounts
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []); // Empty dependency array means this runs only once when the component mounts

  const formik = useFormik({
    initialValues: {
      charities:
        charities.length > 0
          ? charities.map((b) => ({
              id: b.id || null,
              isSelected: b.is_selected || false,
            }))
          : [], // Handle empty state
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      charities: Yup.array().of(
        Yup.object({
          id: Yup.number().nullable(),
          isSelected: Yup.boolean(),
        })
      ),
    }),
    onSubmit: async (values) => {
      console.log("values =>", values);
      try {
        const charities_ids = values.charities
          .filter((charity) => charity.isSelected)
          .map((charity) => charity.id);

        const payload = { charities_ids };
        console.log("payload =>", payload);
        // Check if there are no selected charities or beneficiaries
        if (
          charities_ids.length === 0 &&
          !beneficiaries.some((b) => b.is_selected)
        ) {
          setErrorMessage(
            "You must select someone to inherit your estate. Please either select a charity, or go back and select a beneficiary."
          );
          setLoading(false);
          return; // Exit the function
        } else {
          setErrorMessage("");
          SaveCharity(payload)
            .then((res) => {
              if (res.success && res.status_code === "200") {
                setSelectedCharities([]);
                // toast.success("Charity Save Successfully");
                navigate("/make-will-online/estate/divide");
              } else {
                handleApiError(res, navigate);
              }
              setLoading(false);
            })
            .catch((err) => {
              setLoading(false);
              toast.error("An error occurred");
              console.log(err);
            });
        }

        // If validation passes, clear the error message and proceed
      } catch (error) {
        console.error("API Error:", error);
      }
    },
  });
  const handleDivClick = (data) => {
    const isAlreadySelected = selectedCharities.some(
      (charity) => charity.id === data.id
    );

    if (isAlreadySelected) {
      // Remove the selected charity if already present
      setSelectedCharities((prev) =>
        prev.filter((charity) => charity.id !== data.id)
      );
    } else {
      // Add the charity to the selected list
      // setSelectedCharities((prev) => [...prev, data]);
      setSelectedCharities((prev) => [...prev, { ...data, is_selected: true }]);
    }
  };

  const isSelected = (id) =>
    selectedCharities.some((charity) => charity.id === id);

  console.log("selectedCharities =>", selectedCharities);
  const appendCharity = (appendData) => {
    setCharityData((prevCharities) => {
      const newCharities = appendData.filter(
        (data) => !prevCharities.some((charity) => charity.id === data.id)
      );

      // Update the formik values only for new charities
      formik.setFieldValue(
        "charities",
        [
          ...formik.values.charities,
          ...newCharities.map((data) => ({
            id: data.id,
            isSelected: data.is_selected || false,
          })),
        ],
        false
      );

      return [...prevCharities, ...newCharities];
    });
    // setSelectedCharities([]);
    setOpenModal(false);
  };

  // const selectedCharities = charities.filter((charity) => charity.is_selected);
  return (
    <>
      {contentLoader ? (
        <Loader />
      ) : (
        <>
          <Toaster />
          <Header />
          <div className="container charity-wrapper">
            <form onSubmit={formik.handleSubmit}>
              <div className="grid grid-cols-2 max-lg:grid-cols-1 mt-[30px]">
                <div>
                  <p className="text-[26px] font-semibold">
                    Divide your estate
                  </p>
                  <p className="my-3 text-slate-500">
                    Have you thought about leaving some of your estate to
                    charity?
                  </p>
                  <p className="my-3 text-slate-500">
                    Many people use their will to help charities continue their
                    important work. It has tax benefits, too: if you leave at
                    least 10% of your estate to charity, your inheritance tax
                    rate drops by 4%.
                  </p>

                  <h4 className="text-[20px] font-bold mt-[25px]">
                    Would you like to include a charity?
                  </h4>
                  <p className="text-slate-500">Tick to select a charity.</p>
                  {errorMessage && (
                    <div className="text-[18px] font-semibold mt-4 bg-[#f44336] text-white p-3 rounded">
                      {errorMessage}
                    </div>
                  )}
                  {charities.map((charity, index) => (
                    <div
                      className={`my-5 border-2 pb-3 px-4 GuardianDiv rounded ${
                        formik.values.charities[index]?.isSelected
                          ? "blueBorder"
                          : `border-[#d7d7d7] `
                      } 
                        `}
                      onClick={() => {
                        // Update the state for selected charity
                        const updatedCharities = charities.map((charity, idx) =>
                          idx === index
                            ? { ...charity, is_selected: !charity.is_selected }
                            : charity
                        );
                        setCharityData(updatedCharities);
                        // Update Formik value for selected charity
                        formik.setFieldValue(
                          `charities[${index}].isSelected`,
                          !formik.values.charities[index]?.isSelected
                        );
                        // Check if any item is selected, and update the error message
                        const isAnySelected = updatedCharities.some(
                          (charity) => charity.is_selected
                        );
                        if (isAnySelected) {
                          setErrorMessage("");
                        }
                      }}
                      key={charity.id || index}
                    >
                      <div className="border-[#d7d7d7] rounded-lg">
                        <div className="flex items-center justify-between mt-[16px]">
                          <div className="flex items-center gap-5 w-full">
                            <div className="w-[15%] max-w-[100px]">
                              <img
                                src={charity.charity_image}
                                alt="charity_image"
                                className="w-full h-auto object-cover rounded-md"
                              />
                            </div>

                            <div className="px-1 w-[85%] ">
                              <h4 className="text-[20px] text-black font-bold">
                                {charity.charity_name}
                              </h4>
                              <p className="text-[15px]">
                                {charity.charity_desc}
                              </p>
                            </div>
                          </div>
                          <div>
                            <input
                              name={`charities[${index}].isSelected`}
                              type="checkbox"
                              className={`w-[20px] h-[20px]  ${
                                !charity.is_selected
                                  ? "opacity-50 cursor-not-allowed"
                                  : ""
                              }`}
                              checked={
                                formik.values.charities[index]?.isSelected ||
                                false
                              }
                              onChange={(e) => {
                                // e.stopPropagation(); // Prevent the parent div's onClick from firing
                                formik.setFieldValue(
                                  `charities[${index}].isSelected`,
                                  e.target.checked
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  <div className="my-5 border-b-2 pb-5">
                    <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 ">
                      <div className="flex items-center justify-between mt-[16px]">
                        <div className="flex items-center gap-5 ">
                          <div>
                            <img src="/assets/images/icon-mascot.png" />
                          </div>
                          <div>
                            <h4 className="text-[16px] text-black font-muli font-bold ">
                              Add a charity
                            </h4>
                            <p>Leave part of your estate to a charity </p>
                          </div>
                        </div>
                        <div>
                          <Link>
                            <button
                              onClick={() => setOpenModal(true)}
                              className="border-2 hover:bg-primary hover:text-white rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold"
                            >
                              Add
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between mb-5">
                    <Link to={"/make-will-online/estate/beneficiaries"}>
                      <button
                        type="button"
                        className="flex items-center justify-center gap-1 text-[20px] py-2 rounded-[10px] text-slate-500"
                      >
                        <FaAngleLeft />
                        Back
                      </button>
                    </Link>
                    <button
                      onClick={() => {
                        setLoading(true);
                      }}
                      className="bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex items-center gap-2"
                    >
                      {loading ? <Spinner /> : "Next"}{" "}
                      {!loading ? <FaChevronRight /> : ""}
                    </button>
                  </div>
                </div>

                <div>
                  <div className=" bg-no-repeat max-lg:hidden">
                    <div className="fixed top-[100px] w-[500px] right-[6%]">
                      <img src="/assets/images/2.png" alt="mascot" />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <Modal
            open={openModal}
            onClose={() => setOpenModal(false)}
            center
            classNames={{
              modal: "rounded-[5px] p-5 w-[75%]",
            }}
          >
            <div className="px-2">
              {/* <form> */}
              <div>
                <div>
                  <h4 className="text-black font-bold  text-[22px] sm:text-[26px] lg:text-[28px]">
                    Add a charity
                  </h4>
                  <p className="mt-2">
                    You can select any charity as your beneficiary
                  </p>
                </div>
                <div className="free_search_input" ref={freeSearchInputRef}>
                  <div className="mt-5">
                    <FloatingLabelInput
                      label="Search by name or charity number"
                      type="text"
                      id="search_input"
                      name="search_input"
                      placeholder=""
                      onChange={(e) => handleSearchCharity(e)}
                      value={searchInput}
                    />
                  </div>
                  <div className="dropdown-charity">
                    {searchInput && searchCharity?.length !== 0 ? (
                      <div className="bg-[#fff] h-[265px] overflow-y-auto -bottom-[130px] py-2 px-5 w-[100%] bg-white rounded-lg box-shadow-2">
                        {searchCharity?.map((data, index) => (
                          <div
                            className={`my-3 search-charity border-2 rounded-lg pb-3 px-4 ${
                              isSelected(data.id)
                                ? "blueBorder"
                                : "border-[#d7d7d7]"
                            }`}
                            key={data.id || `charity-${index}`}
                            onClick={() => handleDivClick(data)} // Handle div click
                          >
                            <div className="flex items-center justify-between mt-[10px]">
                              <div className="flex items-center gap-5">
                                <div className="w-[10%]">
                                  <img
                                    src={data.charity_image}
                                    className="w-full object-cover imagaSize"
                                    alt={data.charity_name || "Charity"}
                                  />
                                </div>
                                <div>
                                  <h4 className="text-[18px] w-full text-black font-bold">
                                    {data?.charity_name}
                                  </h4>
                                  <p>
                                    Registered charity number:{" "}
                                    {data?.register_charity_number}
                                  </p>
                                </div>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  className="w-[20px] h-[20px]"
                                  checked={isSelected(data.id)} // Sync checkbox with state
                                  readOnly // Prevent direct modification
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <>
                        {selectedCharities?.map((data, index) => (
                          <div
                            className={`my-3 search-charity border-2 rounded-lg pb-3 px-4 ${
                              isSelected(data.id)
                                ? "blueBorder"
                                : "border-[#d7d7d7]"
                            }`}
                            key={data.id || `charity-${index}`}
                            onClick={() => handleDivClick(data)} // Handle div click
                          >
                            <div className="flex items-center justify-between mt-[10px]">
                              <div className="flex items-center gap-5">
                                <div className="w-[10%]">
                                  <img
                                    src={data.charity_image}
                                    className="w-full object-cover imagaSize"
                                    alt={data.charity_name || "Charity"}
                                  />
                                </div>
                                <div>
                                  <h4 className="text-[18px] w-full text-black font-bold">
                                    {data?.charity_name}
                                  </h4>
                                  <p>
                                    Registered charity number:{" "}
                                    {data?.register_charity_number}
                                  </p>
                                </div>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  className="w-[20px] h-[20px]"
                                  checked={isSelected(data.id)} // Sync checkbox with state
                                  readOnly // Prevent direct modification
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                </div>
                <div className="flex justify-between">
                  <div className="py-5 ">
                    <button
                      type="button"
                      onClick={() => appendCharity(selectedCharities)} // Handle div click
                      className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded flex items-center gap-1 add_selected_charity"
                    >
                      Add selected charity
                    </button>
                  </div>
                </div>
              </div>
              {/* </form> */}
            </div>
          </Modal>
        </>
      )}
    </>
  );
};

export default Charity;
